import React, { useEffect, useState } from "react";
import App from "./App";

import { checkAuth, addValue } from "./sheets.js";

/* Handles authentication 
    Much of this is for interaction with a custom API managed by @BennCon

    *Code here is highly proprietary for interaction with the Google Sheet
    Editing not advised except for styling and text*
*/

const MINS = 2; //Number of minutes between each update of the last active time
function Auth() {
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [row, setRow] = useState(-1);

  //Launch http basic auth
  async function handleAuth() {
    let password = document.getElementById("passInput").value;
    password = encodeURIComponent(password);
    setLoading(true);
    let authData = await checkAuth(password);
    setLoading(false);
    let authVal = authData.auth;
    let authRow = authData.row;
    if (authVal === true) {
      setIsAuth(true);
      setRow(authRow);
    } else {
      alert("Incorrect password");
      document.getElementById("passInput").value = "";
    }
  }

  function auth2() {
    return (
      <div
        id="dialog"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <label for="passInput">Password:</label>
        <input id="passInput" type="password" size="25" autoFocus />
        <button onClick={handleAuth}>Submit</button>
      </div>
    );
  }

  //Detect closing of tab
  window.onbeforeunload = function () {
    if (isAuth) {
      addValue("D" + row, addTime(-MINS));
    }
  };

  //Use effect, doesn't run on first render, only when isAuth changes
  useEffect(() => {
    //Every 5 minutes, update the last active time
    if (isAuth) {
      addValue("D" + row, addTime(MINS));
      const interval = setInterval(() => {
        addValue("D" + row, addTime(MINS));
      }, MINS * 60000);
      return () => clearInterval(interval);
    }
  }, [isAuth]);

  return (
    <>
      {" "}
      {isAuth ? <App /> : auth2()}
      {!isAuth && loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            textAlign: "center",
            color: "white",
          }}
        >
          Loading...
        </div>
      ) : null}
    </>
  );
}

// Must match the spreadsheet's timezone
const SHEET_TZ = "Europe/London";

function addTime(mins) {
  const target = new Date(Date.now() + mins * 60000);
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: SHEET_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(target);
  const p = Object.fromEntries(parts.map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}:${p.second}`;
}

export default Auth;
